var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Connection } from '@solana/web3.js';
import { JITO_RPC_URL, JITO_RPC_URL_2, JITO_RPC_URL_3 } from '../../../utils/config/environment';
var SolanaLoadBalancedClientManager = /** @class */ (function () {
    function SolanaLoadBalancedClientManager() {
        this.urls = [JITO_RPC_URL, JITO_RPC_URL_2, JITO_RPC_URL_3];
        this.windowSize = 1000;
        this.metricsWindowSize = 60000;
        this.endpoints = this.urls.map(function (url) { return ({
            url: url,
            rateLimit: 15,
            lastCallTime: 0,
            callCount: 0,
            windowStart: Date.now(),
            requestTimes: [], // Initialize empty array for tracking request times
        }); });
        this.metrics = {
            totalRequests: 0,
            totalWaits: 0,
            totalWaitTime: 0,
            requestsPerEndpoint: new Map(this.urls.map(function (url) { return [url, 0]; })),
            averageWaitTime: 0,
            peakRequestsPerSecond: 0,
            lastRequestTimes: [],
            errors: new Map(),
        };
        // this.startMetricsLogging();
    }
    SolanaLoadBalancedClientManager.getInstance = function () {
        if (!SolanaLoadBalancedClientManager.instance) {
            SolanaLoadBalancedClientManager.instance = new SolanaLoadBalancedClientManager();
        }
        return SolanaLoadBalancedClientManager.instance;
    };
    SolanaLoadBalancedClientManager.prototype.startMetricsLogging = function () {
        var _this = this;
        setInterval(function () {
            _this.logMetrics();
        }, 5000); // Log every 5 seconds
    };
    SolanaLoadBalancedClientManager.prototype.updateRequestsPerSecond = function () {
        var _this = this;
        var now = Date.now();
        // Remove requests older than our metrics window
        this.metrics.lastRequestTimes = this.metrics.lastRequestTimes.filter(function (time) { return now - time < _this.metricsWindowSize; });
        // Calculate current requests per second
        var requestsPerSecond = this.metrics.lastRequestTimes.length / (this.metricsWindowSize / 1000);
        this.metrics.peakRequestsPerSecond = Math.max(this.metrics.peakRequestsPerSecond, requestsPerSecond);
    };
    SolanaLoadBalancedClientManager.prototype.logMetrics = function () {
        var _this = this;
        var now = Date.now();
        console.log('\n=== Load Balancer Metrics ===');
        console.log("Timestamp: ".concat(new Date(now).toISOString()));
        console.log("Total Requests: ".concat(this.metrics.totalRequests));
        console.log("Current Requests/Second: ".concat(this.metrics.lastRequestTimes.filter(function (time) { return now - time < 1000; }).length));
        console.log("Peak Requests/Second: ".concat(this.metrics.peakRequestsPerSecond.toFixed(2)));
        console.log("Total Wait Events: ".concat(this.metrics.totalWaits));
        console.log("Average Wait Time: ".concat(this.metrics.averageWaitTime.toFixed(2), "ms"));
        console.log('\nEndpoint Status:');
        this.endpoints.forEach(function (endpoint) {
            var remainingCapacity = endpoint.rateLimit - endpoint.callCount;
            var timeSinceLastReset = now - endpoint.windowStart;
            console.log("\nURL: ".concat(endpoint.url));
            console.log("- Current Call Count: ".concat(endpoint.callCount));
            console.log("- Remaining Capacity: ".concat(remainingCapacity));
            console.log("- Time Until Reset: ".concat(Math.max(0, _this.windowSize - timeSinceLastReset), "ms"));
            console.log("- Total Requests: ".concat(_this.metrics.requestsPerEndpoint.get(endpoint.url)));
        });
        if (this.metrics.errors.size > 0) {
            console.log('\nErrors:');
            this.metrics.errors.forEach(function (count, error) {
                console.log("".concat(error, ": ").concat(count, " occurrences"));
            });
        }
    };
    SolanaLoadBalancedClientManager.prototype.calculateOptimalWaitTime = function (endpoint) {
        var now = Date.now();
        // If we're in a new window and haven't reset yet, reset first
        if (now - endpoint.windowStart >= this.windowSize) {
            this.resetWindowIfNeeded(endpoint);
            return 0; // No need to wait if we just reset
        }
        // If we have capacity in the current window, no need to wait
        if (endpoint.callCount < endpoint.rateLimit) {
            return 0;
        }
        // Calculate time until the current window ends
        var timeUntilWindowReset = this.windowSize - (now - endpoint.windowStart);
        // If we're close to a window reset, wait for the reset
        if (timeUntilWindowReset < 100) {
            // If less than 100ms until reset
            return timeUntilWindowReset + 10; // Add 10ms buffer
        }
        // If we have request timestamps, calculate when the next slot will open
        if (endpoint.requestTimes.length >= endpoint.rateLimit) {
            // Get the oldest request in the current window
            var oldestRequest = endpoint.requestTimes[endpoint.requestTimes.length - endpoint.rateLimit];
            var timeUntilSlotFrees = oldestRequest + this.windowSize - now;
            // Return the time until the next slot frees up (with a small buffer)
            return Math.max(timeUntilSlotFrees + 10, 0);
        }
        // Fallback: wait for window reset
        return timeUntilWindowReset;
    };
    SolanaLoadBalancedClientManager.prototype.resetWindowIfNeeded = function (endpoint) {
        var _this = this;
        var now = Date.now();
        if (now - endpoint.windowStart >= this.windowSize) {
            endpoint.windowStart = now;
            endpoint.callCount = 0;
            // Clear old request times
            endpoint.requestTimes = endpoint.requestTimes.filter(function (time) { return now - time < _this.windowSize; });
        }
    };
    SolanaLoadBalancedClientManager.prototype.sleep = function (ms) {
        return __awaiter(this, void 0, Promise, function () {
            var startWait, waitTime;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startWait = Date.now();
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, ms); })];
                    case 1:
                        _a.sent();
                        this.metrics.totalWaits++;
                        waitTime = Date.now() - startWait;
                        this.metrics.totalWaitTime += waitTime;
                        this.metrics.averageWaitTime = this.metrics.totalWaitTime / this.metrics.totalWaits;
                        return [2 /*return*/];
                }
            });
        });
    };
    SolanaLoadBalancedClientManager.prototype.getBestEndpoint = function () {
        var _this = this;
        var now = Date.now();
        this.endpoints.forEach(function (endpoint) { return _this.resetWindowIfNeeded(endpoint); });
        var bestEndpoint = null;
        var shortestWaitTime = Infinity;
        for (var _i = 0, _a = this.endpoints; _i < _a.length; _i++) {
            var endpoint = _a[_i];
            var waitTime = this.calculateOptimalWaitTime(endpoint);
            // // Log endpoint status for debugging
            // console.log(
            //   `Endpoint ${endpoint.url}: Wait time ${waitTime}ms, Calls: ${endpoint.callCount}/${endpoint.rateLimit}`
            // );
            if (waitTime < shortestWaitTime) {
                shortestWaitTime = waitTime;
                bestEndpoint = endpoint;
            }
        }
        return { endpoint: bestEndpoint, waitTime: shortestWaitTime };
    };
    SolanaLoadBalancedClientManager.prototype.getConnection = function () {
        return __awaiter(this, void 0, Promise, function () {
            var startTime, attempts, _a, endpoint, waitTime, error_1, errorMessage;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        startTime = Date.now();
                        attempts = 0;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        _b.label = 2;
                    case 2:
                        if (!true) return [3 /*break*/, 5];
                        attempts++;
                        _a = this.getBestEndpoint(), endpoint = _a.endpoint, waitTime = _a.waitTime;
                        if (!endpoint) {
                            throw new Error('No endpoints available');
                        }
                        if (!(waitTime > 0)) return [3 /*break*/, 4];
                        // console.log(`Waiting ${waitTime}ms for next available slot on ${endpoint.url}`);
                        return [4 /*yield*/, this.sleep(waitTime)];
                    case 3:
                        // console.log(`Waiting ${waitTime}ms for next available slot on ${endpoint.url}`);
                        _b.sent();
                        return [3 /*break*/, 2];
                    case 4:
                        // Update endpoint metrics
                        endpoint.lastCallTime = Date.now();
                        endpoint.callCount++;
                        endpoint.requestTimes.push(Date.now());
                        // Cleanup old request times
                        endpoint.requestTimes = endpoint.requestTimes.filter(function (time) { return Date.now() - time < _this.windowSize; });
                        // Update global metrics
                        this.metrics.totalRequests++;
                        this.metrics.requestsPerEndpoint.set(endpoint.url, (this.metrics.requestsPerEndpoint.get(endpoint.url) || 0) + 1);
                        this.metrics.lastRequestTimes.push(Date.now());
                        this.updateRequestsPerSecond();
                        if (attempts > 1) {
                            console.log("Required ".concat(attempts, " attempts and ").concat(Date.now() - startTime, "ms to get connection"));
                        }
                        return [2 /*return*/, new Connection(endpoint.url)];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_1 = _b.sent();
                        errorMessage = error_1 instanceof Error ? error_1.message : 'Unknown error';
                        this.metrics.errors.set(errorMessage, (this.metrics.errors.get(errorMessage) || 0) + 1);
                        throw error_1;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    SolanaLoadBalancedClientManager.prototype.getMetrics = function () {
        return __assign({}, this.metrics);
    };
    SolanaLoadBalancedClientManager.prototype.getEndpointStatuses = function () {
        var _this = this;
        var now = Date.now();
        return this.endpoints.map(function (endpoint) { return ({
            url: endpoint.url,
            callCount: endpoint.callCount,
            rateLimit: endpoint.rateLimit,
            remainingCapacity: endpoint.rateLimit - endpoint.callCount,
            timeUntilReset: Math.max(0, _this.windowSize - (now - endpoint.windowStart)),
        }); });
    };
    return SolanaLoadBalancedClientManager;
}());
export { SolanaLoadBalancedClientManager };
